const DataModel = require('./export');

module.exports = DataModel.default ? DataModel.default : DataModel;
